import { BaseClient } from '../BaseClient';
import { SavedView, SavedViewList } from '../compiled-protos/saved_view';
import { SavedViewServiceClient } from '../compiled-protos/saved_view.client';

class SavedViewClient extends BaseClient {
  self: SavedViewServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new SavedViewServiceClient(this.transport);
  }

  public async Create(req: SavedView) {
    return await this.self.create(req, this.getMetaData()).response;
  }

  public async Get(req: SavedView) {
    return await this.self.get(req, this.getMetaData()).response;
  }

  public async Update(req: SavedView) {
    return await this.self.update(req, this.getMetaData()).response;
  }

  public async Delete(req: SavedView) {
    return await this.self.delete(req, this.getMetaData()).response;
  }

  public async BatchGet(req: SavedView) {
    return await this.self.batchGet(req, this.getMetaDataWithoutCache()).response;
  }
}

export { SavedView, SavedViewClient, SavedViewList };
